import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { awsUrl, triggerGAEvent } from "../../helpers";
import { useScrollDetectors } from "../../hooks/useScrollDetectors";

import { UnlockedPortalWrapper } from "../../components/UnlockedPortal/Parts";
import UnlockedPortalIntro from "../../components/UnlockedPortal/UnlockedPortalIntro";
import Button from "../../common/Elements/Button";
import { useUserContext } from "../../context/UserContext";

import { FlyThrough, SideBySide } from "../../components/UnlockedPortal/Modules";
import {
  ModuleCopyBody,
  ModuleCopyHeadline,
  ModuleSideHalf
} from "../../components/UnlockedPortal/Modules/Parts";

const Welcome = () => {
  const { setCurrentPage, allVideosPlaying } = useUserContext();
  setCurrentPage("paradize-plaza");

  useScrollDetectors("welcome-portal");

  useEffect(() => {
    document.title = "Carnival | Celebration Key™ | Paradise Plaza";
  }, []);

  return (
    <UnlockedPortalWrapper bgColorClass="bg-green" gaPrefix={`pp`}>
      {/* <div className="absolute">
        {" "}
        <Button onClick={() => setAllVideosPlaying(!allVideosPlaying)}>Toggle Play</Button>
      </div> */}
      <UnlockedPortalIntro isPlaying={allVideosPlaying} portal="welcome" />
      <FlyThrough
        videoName="portals/welcome/unlocked/flythrough"
        media={`image`}
        imgSrc={`${awsUrl}/media/portals/welcome/unlocked/section-2`}
        isPlaying={false}
        headline="Unlock your kind of&nbsp;fun"
        bodyCopy="At Paradise Plaza decide how you'll make the most of your day at Celebration Key, from shopping and cabana rentals, to water sports, shore excursions and more, your adventure begins&nbsp;here."
      ></FlyThrough>
      <FlyThrough
        videoName="portals/welcome/unlocked/suncastle"
        isPlaying={allVideosPlaying}
        media={`video`}
        welcome={true}
        bodyClass={`top-[1rem] lg:top-0 bg-dark-blue`}
        videoHeight={`h-[50%] lg:h-full z-[20] absolute lg:relative lg:z-[1]`}
        gradientTopper={true}
        headline="A giant symbol of&nbsp;paradise"
        bodyCopy="The Suncastle is our larger-than-life walkthrough sandcastle, the highest point at the center of Celebration Key™ and the perfect backdrop to any sun-kissed photo opp. Enjoy spectacular views from the observation deck then take the plunge down one of two racing water slides that weave in and out around the towers of the castle."
        link="Explore sailings to Celebration Key™&nbsp;»"
        gaTriggerEvent={`pp_explore-sailings`}
      ></FlyThrough>
      <SideBySide mobileReverse={true}>
        <ModuleSideHalf className="bg-white">
          <div className="px-4 md:px-10 text-center max-w-[85%]">
            <img
              className="mx-auto mb-3 lg:mb-[25px] w-[70px] lg:w-[77px]"
              src={`${awsUrl}/media/portals/adult-friendly/icon.svg`}
              alt=""
            />
            <ModuleCopyHeadline theme={"dark"}>Visit Calypso&nbsp;Lagoon </ModuleCopyHeadline>
            <ModuleCopyBody theme={"dark"}>
              Our adult-friendly Portal pairs a lively, high-energy vibe with plenty
              of&nbsp;relaxation.
              <div className="block mt-[30px]">
                {" "}
                <Link
                  to={"/portals/calypso-lagoon"}
                  className="font-semibold"
                  onClick={() => {
                    triggerGAEvent("pp_calypso-lagoon");
                  }}
                >
                  <Button color={`bg-[#052049]`} className={`px-16 lg:px-24`}>
                    Explore now
                  </Button>
                </Link>
              </div>
            </ModuleCopyBody>
          </div>
        </ModuleSideHalf>
        <ModuleSideHalf className="bg-dark-blue">
          <div className="w-full h-full relative overflow-hidden">
            <div
              className="absolute bg-cover h-full w-full bg-bottom"
              style={{
                backgroundImage:
                  "url(" + awsUrl + "/media/portals/welcome/unlocked/adult-preview@2x.jpg?v=1)"
              }}
            />
          </div>
        </ModuleSideHalf>
      </SideBySide>
    </UnlockedPortalWrapper>
  );
};

export default Welcome;
